import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./grid-container.css');

// tslint:disable-next-line: interface-over-type-literal
export type Sizes = {
  /** Columns to span from XS size and above */
  xsSpan?: 0 | 1 | 2 | 3 | 4;
  /** Columns to offset from XS size and above */
  xsOffset?: 0 | 1 | 2 | 3;
  /** Columns to span from SM size and above */
  smSpan?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  /** Columns to offset from SM size and above */
  smOffset?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  /** Columns to span from MD size and above */
  mdSpan?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  /** Columns to offset from MD size and above */
  mdOffset?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  /** Columns to span from MD size and above */
  lgSpan?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
  /** Columns to offset from MD size and above */
  lgOffset?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15;
};

/** Props for the component */
export type GridContainerProps = {
  /** Chidren of the container */
  children?: React.ReactNode;
  /** Style name to apply to root element */
  className?: string;
  /** Style name to apply to the inner content element */
  contentClassName?: string;
  /** Vertical alignment within row of inline containers. Default is `top`. */
  verticalAlign?: 'top' | 'bottom';

  /** Optional Definition of any sizes - nested in a field */
  sizes?: Sizes;

  /** Whether to show the debug overlay */
  debug?: boolean;
} /** Optional Definition of any sizes - inlined in props */ & Partial<Sizes>;

/**
 * Basic unit of layout within the responsive grid. Contrains children to a
 * number of columns for each viewport size.
 */
export const GridContainer: React.FunctionComponent<GridContainerProps> = observer((props: GridContainerProps) => {
  const { children, className, contentClassName, verticalAlign = 'top', debug } = props;

  // unpack size variables either from:
  const { lgSpan, lgOffset, mdSpan, mdOffset, smSpan, smOffset, xsSpan, xsOffset } = {
    ...props, // inlined in props or
    ...props.sizes // from nested sizes field.
  };

  return (
    <div
      className={classnames(
        styles.container,
        className,
        styles['verticalAlign-' + verticalAlign],
        xsSpan ? styles.xsVisible : null,
        smSpan ? styles.smVisible : null,
        mdSpan ? styles.mdVisible : null,
        lgSpan ? styles.lgVisible : null,
        xsSpan !== undefined ? styles[`xsSpan${xsSpan}`] : null,
        xsOffset !== undefined ? styles[`xsOffset${xsOffset}`] : null,
        smSpan !== undefined ? styles[`smSpan${smSpan}`] : null,
        smOffset !== undefined ? styles[`smOffset${smOffset}`] : null,
        mdSpan !== undefined ? styles[`mdSpan${mdSpan}`] : null,
        mdOffset !== undefined ? styles[`mdOffset${mdOffset}`] : null,
        lgSpan !== undefined ? styles[`lgSpan${lgSpan}`] : null,
        lgOffset !== undefined ? styles[`lgOffset${lgOffset}`] : null
      )}
    >
      <div className={classnames(styles.content, contentClassName)}>
        <>
          {debug ? <div className={styles.debugOverlay} /> : undefined}
          {children}
        </>
      </div>
    </div>
  );
});

/** Box representing placeholder content */
export class Box extends React.Component {
  render() {
    return <div className={styles.box}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/ui/common/grid-container/grid-container.tsx